<template lang="pug">
  .box
    VueApexCharts(
      type="area"
      height="350"
      :options="chartOptions"
      :series="series"
    )
</template>

<script>
  import VueApexCharts from 'vue-apexcharts'
  import { roundToK } from '@/utils/helper'

  export default {
    name: 'TotalMRRSubTypeChart',

    components: {
      VueApexCharts
    },

    props: ['data'],

    data () {
      return {
      }
    },

    computed: {
      series () {
        return [
          {
            name: 'E-Ticaret',
            data: this.data.map(d => d.sub_types_total.e_commerce.total)
          },
          {
            name: 'Eklenti',
            data: this.data.map(d => d.sub_types_total.plugin.total)
          },
          {
            name: 'Pazaryeri',
            data: this.data.map(d => d.sub_types_total.marketplace.total)
          },
          {
            name: 'POS',
            data: this.data.map(d => d.sub_types_total.pos.total)
          },
        ]
      },

      chartOptions () {
        return {
          chart: {
            height: 350,
            type: 'area',
            stacked: true
          },
          title: {
            text: "MRR Takip",
            align: 'left',
            margin: 10,
          },
          labels: this.data.map(d => d.stat_date),
          colors: ["#176BA0", "#19AADE", "#1DE4BD", "#6CECC1"],
          stroke: {
            curve: 'smooth',
          },
          dataLabels: {
            enabled: true,
            style: {
              fontSize: '12px',
              colors: ["#51507e"]
            },
            formatter: function (value, { seriesIndex, dataPointIndex, w }) {
              let indices = w.config.series.map((item, i) => i);
              if (seriesIndex == Math.max(...indices))
                return "₺ " + roundToK(w.globals.stackedSeriesTotals[dataPointIndex]);
              return '';
            }
          },
          yaxis: {
            labels: {
              formatter: val => {
                return "₺ " + roundToK(val)
              },
              offsetX: -10
            }
          },
          xaxis: {
            tickPlacement: 'between',
            labels: {
              show: true,
              rotate: -45,
              rotateAlways: true,
              hideOverlappingLabels: false,
            }
          },
          tooltip: {
            shared: true,
          },
        }
      }
    },

    methods: {
    }

  }
</script>

<style lang="scss" scoped>
</style>
